"use client";

import MobileBrandSelection from "./home/MobileBrandSelection";
import MobileHeader from "./home/MobileHeader";
import MobileProductList from "./home/MobileProductList";

const MobileBulkOrders: React.FC = () => {
  return (
    <div
      className="w-full"
      // style={{
      //   backgroundImage:
      //     "url('https://yeticycles-prod.zaneray.com/cms/images/4ddadee5-b1b0-4678-ab5e-c783f3d90157_SB160+Carbon+Layup+CTA.jpg?auto=compress,format&rect=0,0,2880,1620&w=2880&h=1620')",
      // }}
    >
      <MobileHeader />

      {/* Content below the header */}
      <div className="w-full h-full relative z-10 pt-[70px] pb-[120px]">
        <MobileBrandSelection />
        <MobileProductList />
      </div>
    </div>
  );
};

export default MobileBulkOrders;
